require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-reason-reroute.json") })
        }
      }, "path---package-reason-reroute");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-reason-reroute!./.cache/json/package-reason-reroute.json
// module id = 903
// module chunks = 231608221292675